import produce from "immer";

import names, { JobSearchActionTypes } from "./jobSearchActionTypes";
import { SearchState } from "./jobSearchState";

export const jobSearchReducer = (
    state: SearchState,
    action: JobSearchActionTypes
) =>
    produce(state, draft => {
        draft.error = undefined;
        draft.hasError = false;
        switch (action.type) {
            case names.SEARCH: {
                draft.searching = true;
                draft.searchCriteria = action.payload.criteria;
                break;
            }

            case names.SEARCH_SUCCESS: {
                draft.searching = false;
                draft.searchResults = action.payload.results;
                break;
            }

            case names.SEARCH_FAILURE: {
                draft.error = action.payload.error;
                draft.searching = false;
                draft.hasError = true;
                break;
            }

            case names.SEARCH_BY_TEXT: {
                draft.searchCriteria.searchText = action.payload.searchText;

                // if we are changing the keyword search then reset the sort field and direction
                draft.searchCriteria.sortField =
                    state.searchCriteria.searchText !==
                    action.payload.searchText
                        ? "rank"
                        : state.searchCriteria.sortField;
                draft.searchCriteria.sortDir =
                    state.searchCriteria.searchText !==
                    action.payload.searchText
                        ? "desc"
                        : state.searchCriteria.sortDir;

                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.NAVIGATE: {
                const index =
                    state.searchCriteria.pageIndex +
                    (action.payload.direction === "next" ? 1 : -1);
                if (index <= state.searchResults.totalPages && index >= 0) {
                    draft.searchCriteria.pageIndex = index;
                }
                break;
            }

            case names.SEARCH_BY_SELECTED_FILTERS: {
                draft.searchCriteria.searchText = action.payload.searchText;
                draft.searchCriteria.searchRadiusInMeters =
                    action.payload.distance;
                draft.searchCriteria.locationId = action.payload.locationId;
                draft.searchCriteria.locationName = action.payload.locationName;
                draft.searchCriteria.pageIndex = 1;
                break;
            }
            case names.FILTER_SINGLE: {
                if (action.payload.item && action.payload.item.value) {
                    draft.searchCriteria[action.payload.id] = parseFloat(
                        action.payload.item.value
                    );
                    draft.searchCriteria[action.payload.name] =
                        action.payload.item.label;
                } else {
                    draft.searchCriteria[action.payload.id] = undefined;
                    draft.searchCriteria[action.payload.name] = undefined;
                }
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.FILTER_MULTIPLE: {
                const currentIds: any[] =
                    draft.searchCriteria[action.payload.id] || [];
                const currentNames: any[] =
                    draft.searchCriteria[action.payload.name] || [];
                if (action.payload.item && action.payload.item.value) {
                    const newItemId = parseFloat(action.payload.item.value);
                    if (currentIds.indexOf(newItemId) === -1) {
                        currentIds.push(newItemId);
                        currentNames.push(action.payload.item.label);
                    }
                } else {
                    if (action.payload.category) {
                        const index = currentNames.indexOf(
                            action.payload.category
                        );
                        currentIds.splice(index, 1);
                        currentNames.splice(index, 1);
                    }
                }

                draft.searchCriteria[action.payload.id] = currentIds;
                draft.searchCriteria[action.payload.name] = currentNames;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.SORT: {
                let dir: SortDir = "asc";
                if (draft.searchCriteria.sortField === action.payload.field) {
                    dir =
                        draft.searchCriteria.sortDir === "asc" ? "desc" : "asc";
                }
                draft.searchCriteria.sortField = action.payload.field;
                draft.searchCriteria.sortDir = dir;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.SORT_MOBILE: {
                draft.searchCriteria.sortField = action.payload.field;
                draft.searchCriteria.sortDir = action.payload.direction;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.CLEAR_ERRORS: {
                draft.error = undefined;
                draft.hasError = false;
                break;
            }
        }
    });
